import { render, staticRenderFns } from "./Eula-modal.vue?vue&type=template&id=2b1c2e53&scoped=true&"
import script from "./Eula-modal.vue?vue&type=script&lang=ts&"
export * from "./Eula-modal.vue?vue&type=script&lang=ts&"
import style0 from "./Eula-modal.vue?vue&type=style&index=0&id=2b1c2e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c2e53",
  null
  
)

export default component.exports